import React, { useState, useEffect } from "react";

import useHttp from "../../hooks/useHttp";
import { TRANSACTION_GET_URL } from "../../utils/api-ends";
import LoaderImg from "../../assets/media/loader.gif";

const Transaction = () => {
  const [allValue, setAllValue] = useState([]);
  const { isLoading, sendRequests } = useHttp();
  const [nextPageNumber, setNextPageNumber] = useState(null);

  const fetchTransactionData = (params = {}, isLoadingMoreData = false) => {
    const desired_timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const response = (data) => {
      if (isLoadingMoreData) {
        setAllValue((prevS) => [...prevS, ...data.results]);
      }else{
		setAllValue(data.results);
	  }
      setNextPageNumber(data?.pagination?.next_page_number);
    };
    // Send request to get Transaction list
    sendRequests(
      {
        url: TRANSACTION_GET_URL,
        method: "GET",
        params: {
          ...params,
          desired_timezone: desired_timezone,
        },
      },
      response
    );
  };

  useEffect(() => {
    fetchTransactionData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Scroll Pagination
  window.onscroll = function (ev) {
    //Check if scroll to the bottom
    if (
      window.innerHeight + window.scrollY >= document.body.offsetHeight &&
      nextPageNumber
    ) {
		fetchTransactionData({page: nextPageNumber}, true)
    }
  };

  return (
    <>
      <section className="transaction-history">
        <div className="container theme-section">
          <h1 className="tr-title text-center"> Load Transaction History </h1>
          <div className="transaction-table-area">

              <div className="transaction-table">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">Transition Date</th>
                      {/*<th scope="col">Details</th>*/}
                      <th scope="col">Type</th>
                      <th scope="col">Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allValue?.length > 0 ? (
                      allValue?.map((value, index) => (
                        <tr>
                          <td> {value.trans_created_at} </td>
                          <td> {value.transaction_type} </td>
                          <td> $ {value.amount} </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <p>No transaction data available</p>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

          </div>
          {isLoading && (
            <div className="loader d-flex justify-content-center mb-5 mt-5">
              <img style={{ width: "35px" }} src={LoaderImg} alt="" />
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default Transaction;
